export class Model {
  public static getYears(initialYear = 2017) {
    const years = [];
    for (let i = new Date().getFullYear(); i >= initialYear; i--) {
      years.push(i.toString());
    }

    return years;
  }

  public static generateCollectionFromApi(rawTypes) {
    const collection = [];

    for (const object of rawTypes) {
      collection.push(new this(object));
    }

    return collection;
  }

  public static generateCollectionFromEndpoint(rawTypes) {
    const collection = [];

    for (const object of rawTypes) {
      collection.push(new this().apiMap(object));
    }

    return collection;
  }

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  public apiMap(values: Object = {}) {}

  public serialize() {
    const record = {};

    for (const key of Object.keys(this)) {
      record[key] = this[key];
    }
    return record;
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/model.ts